// @flow
import React, { useContext } from 'react';
import { SPUserCommitDetailsContext } from '@streaming-projects/user-commit-details/contexts/SPUserCommitDetailsContext';
import { SPOrgContext } from '@streaming-projects/orgs/contexts/SPOrgContext';
import { WarningMessageContainer } from '@presentational/messages/WarningMessageContainer';
import { getIfCustomerViewIsEnabled } from '@src/common-utils/utils';
import { If } from '@presentational/If';

export const SPConnectTasksAlertContainer = () => {
  const commitData = useContext(SPUserCommitDetailsContext);
  const spOrgData = useContext(SPOrgContext);
  const isCustomerViewEnabled = getIfCustomerViewIsEnabled(spOrgData);
  const isConnectorsAlertSentByBE =
    commitData?.alert_aggregations?.connector_alert?.show_connector_alert ?? false;
  const shouldShowAlert = isConnectorsAlertSentByBE && !isCustomerViewEnabled;

  return (
    <If test={shouldShowAlert}>
      <WarningMessageContainer message="ALERT: High Connect task count, customer is eligible for add'l Connect-specific discounts. Do NOT quote list price on Connect for this account." />
    </If>
  );
};
